import { PayloadAction, createSlice } from '@reduxjs/toolkit'

type BaseNotification<T extends string> = {
  type: T
}

type AddProductNotification = BaseNotification<'ADD_PRODUCT'> & {
  productId: string
  skipOpen: boolean
}

type Notification = AddProductNotification

export interface NotificationsState {
  notifications: Notification[]
}

const initialState: NotificationsState = {
  notifications: [],
}

export const notificationSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Notification>) => {
      return {
        notifications: state.notifications.filter((n) => n.type !== action.payload.type).concat(action.payload),
      }
    },
    clearNotification: (state, action: PayloadAction<Notification['type']>) => {
      return {
        notifications: state.notifications.filter((n) => n.type !== action.payload),
      }
    },
    resetOverlayState: () => initialState,
  },
})

export const { addNotification, clearNotification } = notificationSlice.actions

export default notificationSlice.reducer
